const isLang = /lang-\w\w(_\w\w){0,1}(\/)*/i;

export default isLang;
